module.exports = __webpack_public_path__ + "img/ico-expand.ab131d38.svg";